"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const Card_vue_1 = require("@/client/components/card/Card.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'stacked-cards',
    props: {
        cards: {
            type: Array,
            required: true,
        },
    },
    components: {
        Card: Card_vue_1.default,
    },
});
